/*
 * This file is part of glowingblue/orell-bookshelf.
 *
 * Copyright (c) 2026 Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import LiteraryWorkState from 'flarum/orell-articles/states/LiteraryWorkState';

export default function (): void {
	extend(LiteraryWorkState.prototype, 'params', function (params) {
		const includeToAdd = 'articles.note';

		if (!params.include) {
			params.include = includeToAdd;
			return;
		}

		const parts = params.include.split(',').map((part) => part.trim());
		if (!parts.includes(includeToAdd)) {
			params.include = `${params.include},${includeToAdd}`;
		}
	});
}
